import { socialApiClient } from '@/shared/api-client/social-api-client';
import type { QueryStatus } from '../query-types';

export const getQueryStatus = async (
  workspaceId: string,
  queryId: string,
): Promise<QueryStatus[]> => {
  const response = await socialApiClient.get(
    `workspaces/${workspaceId}/queries/${queryId}/scraping_status`,
  );
  return await response.json();
};

export const deleteQuery = async ({
  workspaceId,
  queryId,
}: {
  workspaceId: string;
  queryId: string;
}): Promise<void> => {
  await socialApiClient.delete(`workspaces/${workspaceId}/queries/${queryId}`);
};
